import { Controller } from "stimulus";

class SimpleGauge extends Controller {
  static targets = [
    'gauge',
    'gaugeFill',
    'gaugeCover'
  ]

  static values = {
    rating: Number,
    text: String,
    symbol: String,
    premium: String
  }

  connect() {
    this.gaugeElement = this.gaugeTarget;
    this.setGauge();
  }

  setGauge() {
    const rating = (this.ratingValue < 50 ? this.ratingValue : (100 - this.ratingValue))
    const value = this.ratingValue / 100;
    if (value < 0 || value > 1) {
      return;
    }

    if(this.premiumValue === 'true') {
      this.gaugeFillTarget.style.transform = `rotate(${value / 2}turn)`;
      this.gaugeCoverTarget.innerHTML = `
        <span class='t-leading-tight t-text-xs t-uppercase'>${this.textValue}</span>
        <span class='t-leading-tight t-font-semibold t-text-3xl sm:t-text-2xl'>${rating}%</span>
        <span class='t-leading-tight t-font-semibold t-text-md'>${this.symbolValue}</span>`;
    } else {
      this.gaugeFillTarget.style.transform = `rotate(${0}turn)`;
      this.gaugeCoverTarget.innerHTML = `
        <span class='t-leading-tight t-text-mitre-blue-100 t-font-semibold t-text-2xl'>${this.symbolValue}</span>`;
    }
  }
}

export default SimpleGauge;

